import api from "../api";
import moment from "moment"
import * as CONSTANTS from "@/store/constants";

export default {
    methods: {
        async getAllBookmarks(offset) {
            let bookmarks = await api.getBookmarks(offset);
            return bookmarks.data;
        }, 
        

        getBookmarkTarget(url) {
            if (!url) return "_blank";

            // Logic adapted from LinkMixin to avoid dependency on Header component instance
            // Check if the URL is internal to Autodesk One, Employee Hub, SharePoint or ServiceNow
            
            const isRelative = url.startsWith("/");
            
            // Check globals if available
            const isAdskOne = typeof ADSK_ONE_BASE_URL !== 'undefined' && url.includes(ADSK_ONE_BASE_URL);
            const isHelpHub = typeof HELP_HUB_DOMAIN !== 'undefined' && url.includes(HELP_HUB_DOMAIN);
            const isEmployeeHub = typeof EMPLOYEE_HUB_DOMAIN !== 'undefined' && url.includes(EMPLOYEE_HUB_DOMAIN);
            
            // Check Constants
            const isSnow = url.includes(CONSTANTS.SNOW_PRODURL);
            
            // Common SharePoint domains
            const isSharePoint = url.includes("share.autodesk.com") || url.includes("autodesk.sharepoint.com");

            // Logic matches LinkMixin: SharePoint is only "internal" (_self) if running in Teams.
            // In a standard browser, it should open in a new tab (_blank).
            const isTeams = this.$aoneTeamsHost;

            if (isRelative || isAdskOne || isHelpHub || isEmployeeHub || isSnow || (isTeams && isSharePoint)) {
                return "_self";
            }
            
            return "_blank";
        },

        filterBookmarks(formattedbookmarks) {
            return formattedbookmarks.filter(b => b.title && b.title.length > 0);
        }

    }
}
